export default "__VITE_ASSET__xs1GmtIe__"